import { render } from "./CardTitle.vue?vue&type=template&id=3c8baea3"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"
script.render = render

export default script